import { render, staticRenderFns } from "./NftStatistic.vue?vue&type=template&id=90b59cb4&scoped=true&"
import script from "./NftStatistic.vue?vue&type=script&lang=js&"
export * from "./NftStatistic.vue?vue&type=script&lang=js&"
import style0 from "./NftStatistic.vue?vue&type=style&index=0&id=90b59cb4&prod&lang=scss&scoped=true&"
import style1 from "./NftStatistic.vue?vue&type=style&index=1&id=90b59cb4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90b59cb4",
  null
  
)

export default component.exports